import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaChevronLeft, FaChevronRight, FaExternalLinkAlt } from 'react-icons/fa';
import useMediaQuery from '../hooks/useMediaQuery';

import dev2 from '../images/wtm-batna-website.png';
import dev3 from '../images/chawerni.png';
import dev4 from '../images/devfest23-batna-landing-page.png';
import dev5 from '../images/formadziri.png';
import dev6 from '../images/mr-merdaoui-portfolio.png';
import dev7 from '../images/textgenie.png';
import logo1 from '../images/graphic-design/logos/qaresto.png';
import logo2 from '../images/graphic-design/logos/shakie.png';
import logo3 from '../images/graphic-design/logos/reed-club.png';
import logo4 from '../images/graphic-design/logos/kube.png';
import logo5 from '../images/graphic-design/logos/the-petal-podcast.png';
import logo6 from '../images/graphic-design/logos/mutqin.png';
import logo7 from '../images/graphic-design/logos/rook-and-roll.png';
import logo8 from '../images/graphic-design/logos/ytech.png';
import logo9 from '../images/graphic-design/logos/palita.png';
import logo10 from '../images/graphic-design/logos/mcbell.png';
import brandingDoc from '../images/graphic-design/branding/mcbell-branding.png';
import socialPosts3 from '../images/graphic-design/social/wtm-social-media.png';
import socialTemplate from '../images/graphic-design/social/wtm-templates.png';
import socialPosts9 from '../images/graphic-design/social/tpp-social-media.png';
import landing1 from '../images/graphic-design/web/gradia-page.png';
import landing2 from '../images/graphic-design/web/tpp-page.png';
import landing3 from '../images/graphic-design/web/castudy-page.png';
import landing4 from '../images/graphic-design/web/razanes-page.png';
import landing5 from '../images/graphic-design/web/palita-page.png';

const categories = [
  { id: 'web', label: 'Web Design' },
  { id: 'social', label: 'Social Media' },
  { id: 'development', label: 'Development' },
  { id: 'logos', label: 'Logos' },
  { id: 'branding', label: 'Branding' },
];

const projects = [
  { id: 25, src: landing5, category: 'web', title: 'Palita Page' },
  { id: 24, src: landing4, category: 'web', title: "Razane's Page" },
  { id: 23, src: landing3, category: 'web', title: 'Castudy Page' },
  { id: 22, src: landing2, category: 'web', title: 'TPP Page' },
  { id: 21, src: landing1, category: 'web', title: 'Gradia Page' },
  { id: 20, src: socialPosts9, category: 'social', title: 'TPP Social Media' },
  { id: 19, src: socialTemplate, category: 'social', title: 'WTM Templates' },
  { id: 18, src: socialPosts3, category: 'social', title: 'WTM Social Media' },
  { id: 17, src: brandingDoc, category: 'branding', title: 'McBell Branding' },
  { id: 16, src: logo10, category: 'logos', title: 'McBell' },
  { id: 15, src: logo9, category: 'logos', title: 'Palita' },
  { id: 14, src: logo8, category: 'logos', title: 'YTech' },
  { id: 13, src: logo7, category: 'logos', title: 'Rook & Roll' },
  { id: 12, src: logo6, category: 'logos', title: 'Mutqin' },
  { id: 11, src: logo5, category: 'logos', title: 'The Petal Podcast' },
  { id: 10, src: logo4, category: 'logos', title: 'Kube' },
  { id: 9, src: logo3, category: 'logos', title: 'REED Club' },
  { id: 8, src: logo2, category: 'logos', title: 'Shakie' },
  { id: 7, src: logo1, category: 'logos', title: 'Qaresto' },
  { id: 2, src: dev2, category: 'development', title: 'WTM Batna Website', description: 'My first real website project — see how far I have come since then!', link: 'https://wtmbatna.netlify.app/' },
  { id: 3, src: dev3, category: 'development', title: 'Chawerni', description: 'A consultant platform prototype that passed the start-up label with an impressive 9/10 score!', link: 'https://chawerni.netlify.app/' },
  { id: 4, src: dev4, category: 'development', title: 'Devfest23 Batna Landing Page', description: 'A team project with Google Developers Group bringing Devfest to Batna in 2023 for a hackathon.', link: 'https://devfest2023-batna2-git-main-54fiadj.vercel.app/' },
  { id: 5, src: dev5, category: 'development', title: 'Formadziri', description: 'Bringing extracurricular education in Algeria to the online world. A work in progress!', link: 'https://formadziri.com/coming-soon' },
  { id: 6, src: dev6, category: 'development', title: 'UI/UX Designer Portfolio', description: 'Hired by a UI/UX designer to develop and bring their portfolio vision to life.', link: 'https://amine-merdaoui.netlify.app/' },
  { id: 7, src: dev7, category: 'development', title: 'TextGenie', description: 'Generative AI Everywhere You Type. AI commands that work seamlessly across your desktop, enabling you to have the best typing experience.', link: 'https://www.text-genie.com/' },
];

const PortfolioGrid = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const [activeCategory, setActiveCategory] = useState(categories[0].id);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const scrollRef = useRef(null);

  const filtered = [...projects].reverse().filter(p => p.category === activeCategory);
  const isScrollable = activeCategory === 'web' || activeCategory === 'branding';
  const isDev = activeCategory === 'development';

  const openLightbox = (index) => setSelectedIndex(index);
  const closeLightbox = () => setSelectedIndex(null);

  const goNext = () => {
    if (selectedIndex !== null && selectedIndex < filtered.length - 1) {
      setSelectedIndex(selectedIndex + 1);
      if (scrollRef.current) scrollRef.current.scrollTop = 0;
    }
  };

  const goPrev = () => {
    if (selectedIndex !== null && selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
      if (scrollRef.current) scrollRef.current.scrollTop = 0;
    }
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-10">
        {categories.map(cat => (
          <button
            key={cat.id}
            onClick={() => setActiveCategory(cat.id)}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
              activeCategory === cat.id
                ? 'bg-primary text-white shadow-lg shadow-primary/25'
                : 'bg-accent text-textlight hover:bg-border border border-border'
            }`}
          >
            {cat.label}
          </button>
        ))}
      </div>

      <motion.div layout={!isMobile} className={`grid gap-6 ${
        activeCategory === 'logos'
          ? 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'
          : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'
      }`}>
        <AnimatePresence mode={isMobile ? 'sync' : 'popLayout'}>
          {filtered.map((project, index) =>
            isDev ? (
              <motion.a
                key={project.id}
                layout={!isMobile}
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                {...(!isMobile ? {
                  initial: { opacity: 0, y: 30 },
                  animate: { opacity: 1, y: 0 },
                  exit: { opacity: 0, scale: 0.9 },
                  transition: { duration: 0.3, delay: index * 0.05, ease: [0.16, 1, 0.3, 1] }
                } : {})}
                className="group block bg-accent rounded-2xl overflow-hidden border border-border card-hover"
              >
                <div className="img-zoom h-56">
                  <img src={project.src} alt={project.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-text mb-2">{project.title}</h3>
                  <p className="text-sm text-textlight mb-4 leading-relaxed">{project.description}</p>
                  <span className="inline-flex items-center gap-2 text-sm font-medium text-primary group-hover:gap-3 transition-all duration-300">
                    View Project <FaExternalLinkAlt className="text-xs" />
                  </span>
                </div>
              </motion.a>
            ) : (
              <motion.button
                key={project.id}
                layout={!isMobile}
                {...(!isMobile ? {
                  initial: { opacity: 0, scale: 0.9 },
                  animate: { opacity: 1, scale: 1 },
                  exit: { opacity: 0, scale: 0.9 },
                  transition: { duration: 0.3, ease: [0.16, 1, 0.3, 1] }
                } : {})}
                onClick={() => openLightbox(index)}
                className="group bg-accent rounded-2xl overflow-hidden border border-border card-hover text-left"
              >
                {isScrollable ? (
                  <div className="w-full max-h-[300px] overflow-hidden">
                    <img src={project.src} alt={project.title} className="w-full object-cover object-top" />
                  </div>
                ) : (
                  <div className="img-zoom aspect-[4/3]">
                    <img src={project.src} alt={project.title} className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="p-4">
                  <p className="text-sm font-medium text-text">{project.title}</p>
                </div>
              </motion.button>
            )
          )}
        </AnimatePresence>
      </motion.div>

      <AnimatePresence>
        {selectedIndex !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/90 flex"
            onClick={closeLightbox}
          >
            <button onClick={closeLightbox} className="absolute top-4 right-4 text-white/80 hover:text-white text-2xl z-20">
              <FaTimes />
            </button>

            {selectedIndex > 0 && (
              <button onClick={(e) => { e.stopPropagation(); goPrev(); }} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white text-2xl z-20">
                <FaChevronLeft />
              </button>
            )}

            {selectedIndex < filtered.length - 1 && (
              <button onClick={(e) => { e.stopPropagation(); goNext(); }} className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white text-2xl z-20">
                <FaChevronRight />
              </button>
            )}

            {isScrollable ? (
              <div ref={scrollRef} className="w-full h-full overflow-y-auto mt-16 mb-8" onClick={(e) => e.stopPropagation()}>
                <motion.img
                  key={filtered[selectedIndex].id}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  src={filtered[selectedIndex].src}
                  alt={filtered[selectedIndex].title}
                  className="w-full"
                />
              </div>
            ) : (
              <div className="flex items-center justify-center w-full h-full p-4">
                <motion.img
                  key={filtered[selectedIndex].id}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.2 }}
                  src={filtered[selectedIndex].src}
                  alt={filtered[selectedIndex].title}
                  className="max-w-full max-h-[90vh] object-contain rounded-lg"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PortfolioGrid;
